module.exports = __webpack_public_path__ + "img/26.ee21b6e2.jpg";